(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cosycosmos-squishy-hero"] && !Shopify.designMode) return;
  try {
    
  const productRotationMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  function pauseReducedProductRotations() {
    if (!productRotationMotion.matches) return;
    for (const carousel of document.querySelectorAll('.cc-squish__carousel')) {
      carousel.setAttribute('paused', '');
      carousel.pause?.();
    }
  }
  pauseReducedProductRotations();
  customElements.whenDefined('slideshow-component').then(pauseReducedProductRotations);
  document.addEventListener('shopify:section:load', pauseReducedProductRotations);
  productRotationMotion.addEventListener('change', pauseReducedProductRotations);
  document.addEventListener('focusin', (event) => {
    if (!(event.target instanceof Element)) return;
    event.target.closest('.cc-squish__carousel')?.pause?.();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
